export const environment = {
    DefaultLanguage: "en",
    production: false,
    development: true,
    environmentName: "DEV",
    baseURL: "http://localhost:1941/",
    API_URL: 'https://secure2.grammarin.com', // environment.API_URL+
    CaptchaKey: '1x00000000000000000000AA', // environment.CaptchaKey
    AuthorizationGIN: 'Bearer 2685bb3a2ffc6eabccc3b6ebbfee886cd2d7061e'
};

export const GINConstants = { key: 'value' }; // console.log(GINConstants.key);